import { Button } from '@heroui/react';
import { RiMenuLine } from '@remixicon/react';
import { ToastContainer } from 'react-toastify';
import { useAtomValue, useSetAtom } from 'jotai';
import { motion, AnimatePresence } from 'framer-motion';

import { Sidebar } from '@/components/sidebar';
import { sidebarCollapsedAtom } from '@/store';

import 'react-toastify/dist/ReactToastify.css';

export default function DefaultLayout({ children }: { children: React.ReactNode }) {
  const isCollapsed = useAtomValue(sidebarCollapsedAtom);
  const setCollapsed = useSetAtom(sidebarCollapsedAtom);

  const handleMobileMenuToggle = () => {
    setCollapsed(!isCollapsed);
  };

  return (
    <section className="relative flex bg-gradient-to-bl from-blue-200 to-blue-50 dark:from-[#091133] dark:to-[#132057]">
      <Sidebar />
      <main className="relative min-h-screen flex-1 overflow-x-hidden overflow-y-auto px-4 pt-4">
        <motion.div
          className="bg-gradient-background-light dark:bg-gradient-background-dark h-full rounded-t-2xl shadow-lg"
          animate={{
            marginLeft: isCollapsed ? 0 : 0,
            transition: { duration: 0.3, ease: 'easeInOut' }
          }}
        >
          <Button
            isIconOnly
            variant="shadow"
            onPress={handleMobileMenuToggle}
            className="absolute top-0 left-0 z-40 bg-white md:hidden"
          >
            <RiMenuLine />
          </Button>
          {children}
        </motion.div>
      </main>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </section>
  );
}
